<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">
          <b>首页</b>
        </el-breadcrumb-item> -->
        <el-breadcrumb-item>转换结果</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <!--工具条 begin-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="文章名：">
          <el-input v-model="searchForm.articleTitle" placeholder="文章名"></el-input>
        </el-form-item>
        <el-form-item label="DOI：">
          <el-input v-model="searchForm.articleDoi" placeholder="DOI"></el-input>
        </el-form-item>
        <el-form-item label="期刊：" prop="journalName">
            <el-select v-model="searchForm.journalId" filterable clearable placeholder="请选择期刊">
                <el-option
                v-for="item in journals"
                :key="item.journalId"
                :label="item.journalName"
                :value="item.journalId"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="出版类型：" prop="pubName">
            <el-select v-model="searchForm.pubId" filterable clearable placeholder="出版类型">
                <el-option
                v-for="item in pubs"
                :key="item.pubId"
                :label="item.pubName"
                :value="item.pubId"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="转换类型：" prop="processName">
            <el-select v-model="searchForm.processId" filterable clearable placeholder="转换类型">
                <el-option
                v-for="item in processList"
                :key="item.processId"
                :label="item.processName"
                :value="item.processId"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="findResult(null)">查询</el-button>
        </el-form-item>
    </el-form>
    </el-col> 
    <!--工具条 end-->

    <!-- 列表显示 begin-->
    <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
    <el-table :data="logs" style="width: 100%;overflow: auto;" stripe highlight-current-row v-loading="tableLoading" class="tablebar">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="开始时间：">
              <span>{{ props.row.createTime }}</span>
            </el-form-item>
            <el-form-item label="完成时间：">
              <span>{{ props.row.finishTime }}</span>
            </el-form-item>
            <el-form-item label="转换文件存储位置：">
              <span>{{ props.row.transUrl }}</span>
            </el-form-item>
            <el-form-item label="ftp存储位置：">
              <span>{{ props.row.ftpUrl }}</span>
            </el-form-item>
            <el-form-item label="doi:">
              <span>{{ props.row.doi }}</span>
            </el-form-item>
            <el-form-item label="ISSN：">
              <span>{{ props.row.issn }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <!-- 第一行显示数据 -->
      <!-- <el-table-column
        type="index"
        width="50">
      </el-table-column> -->
      <el-table-column prop="articleName" label="文章名称" sortable align="center"></el-table-column>
      <el-table-column prop="issn" label="ISSN" sortable align="center"></el-table-column>
      <el-table-column prop="pubName" label="出版类型" sortable align="center">
        <template slot-scope="scope">
          <el-tag
            type="primary"
            disable-transitions>{{scope.row.pubName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="processName" label="处理方法" sortable align="center">
        <template slot-scope="scope">
          <el-tag
            type="primary"
            disable-transitions>{{scope.row.processName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="transformStatus" label="转换结果" sortable align="center">
        <template slot-scope="scope">
          <el-tooltip
            placement="top-start"
            effect="light"
            class="item"
            :disabled="scope.row.transformStatus === 0 ? false : true"
          >
          <div slot="content">
            <span>{{scope.row.transformErrorInfo}}</span>
          </div>
          <el-tag
            :type="scope.row.transformStatus === 1 ? 'success' : 'danger'"
            disable-transitions>{{scope.row.transformInfo}}</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="完成时间">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <!-- 操作按钮 -->
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="downLoad(scope.$index, scope.row)">下载</el-button>
          <!--<el-button type="primary" size="mini" :style="(scope.row.downloadStatus === 0 || scope.row.sendStatus === 0) ? { display: '' } : { display: 'none' }" @click="reTry(scope.$index, scope.row)">重试</el-button>-->
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </el-table>
    </el-col>
    <!-- 列表显示 end-->
    <!--底部分页-->
    <el-col :span="24" class="foolbar">
        <!-- hide-on-single-page  -->
      <el-pagination 
        background 
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pageSize"
        :page-sizes = pageSizes
        :total="total" 
        hide-on-single-page 
        style="float:right;">
      </el-pagination>
    </el-col>
    <!-- 在此添加新的页面元素 -->
  </el-row>
</template>

<script>
import API_LOG from "../../api/api_log";
import API_JOURNAL from "../../api/api_journal";
import API_PROCESS from "../../api/api_process";
import API_PUB from "../../api/api_pub";

export default {
  data() {
    return {
        searchForm:{
          articleTitle:"",
          articleDoi:"",
          journalId:"",
          pubId:"",
          processId:"",
        },
        journals:[],
        pubs:[],
        processList:[],

        //列表显示相关数据
        log:{},
        logs: [],
        //页码
        page: 1,
        //每页数量
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        //总数
        total: 0,
        clientHeight: window.innerHeight - 258,
        //页面载入状态
        tableLoading: false,
    };
  },
  methods: {
    //获取所有结果
    findAllLogs(){
      this.tableLoading = true
      let that = this;
      let params = {
        page: that.page,
        pageSize: that.pageSize,
      };
      API_LOG.getLogs(params)
      .then(res=>{
        if(res && res.logs){
          that.logs = Object.values(res.logs);
          that.total = res.total;
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      }).finally(()=>{
        this.tableLoading = false
      });
    },

    //通过logId从后台获取转换结果详细信息
    findLog(_logId) {
      let that = this;
      let params = {
        logId: _logId
      };
      console.log("......findLog params:" + JSON.stringify(params));
      //发送http请求
      API_LOG.getLog(params)
        .then(res => {
          if (res) {
            //赋值
            that.log = res;
            console.log("......findLog res:" + JSON.stringify(that.log));
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    //获取出版类型列表
    findAllPubs(){
      let that = this;
      API_PUB.getPubs()
      .then(res=>{
        if(res && res.pubs){
          that.pubs = Object.values(res.pubs);
          console.log(
              "......findAllPubs:" + JSON.stringify(that.pubs)
            );
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      });
    },

    //获取处理类型列表
    findAllProcess(){
      let that = this;
      API_PROCESS.getAllProcess()
      .then(res=>{
        if(res && res.process){
          that.processList = Object.values(res.process);
          console.log(
              "......findProcesses:" + JSON.stringify(that.processList)
            );
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      });
    },

    //
    searchLogs() {
      let that = this;
      this.tableLoading = true
      let params = {
        articleName: that.searchForm.articleTitle,
        doi: that.searchForm.articleDoi,
        journalId: that.searchForm.journalId,
        pubId: that.searchForm.pubId,
        processId: that.searchForm.processId,
        page: that.page,
        pageSize: that.pageSize,
      };
      console.log("......searchLogs params:" + JSON.stringify(params));
      //发送http请求
      API_LOG.searchLogs(params)
        .then(res => {
            if(res && res.logs){
                that.logs = Object.values(res.logs);
                that.total = res.total;
                console.log(
                    "......searchLogs:" + JSON.stringify(that.logs)
                );
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        }).finally(()=>{
          this.tableLoading = false
        });
    },
    
    //显示编辑对话框
    downLoad: function(index, row) {
      console.log("........ins edit row:" + JSON.stringify(row));
      let that = this;
      let params = {
        transUrl: row.transUrl
      };
      API_LOG.downloadZip(params)
        .then(res => {
          if (navigator.userAgent.match(/MSIE\s([\d.]+)/) ||navigator.userAgent.indexOf("Trident") > -1) {
                window.navigator.msSaveBlob(res, row.fileName);
          } 
          else {
            const blob = new Blob([res]);
            const fileName = row.fileName;
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    reTry(index, row){
      let params = {
        doi: row.doi,
        issn: row.issn,
        pubType: row.pubName,
        articleName: row.articleName,
        downloadUrl: row.downloadUrl,
      };
      console.log("......reTry params:" + JSON.stringify(params));

    },

    //根据机构Id获取与其关联的期刊
    getJournalList(){
        let that = this;
        let params = {};
        API_JOURNAL.getJournalList(params)
        .then(res=>{
            if(res && res.journal){
            that.journals = Object.values(res.journal);
            console.log(
                "......getJournalList:" + JSON.stringify(that.journals)
                );
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求出现异常",
            duration:2000
            });
        });
    },

    getRows: function(_page) {
      this.page = _page;
      this.searchLogs();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.searchLogs();
      },

    //分页选择处理
    handleCurrentChange: function(val) {
      this.getRows(val);
    },

    findResult(){
      //点击查询按钮，分页初始化为1
      let _page = 1;
      //重新搜索时进行重置
      this.total = 0;
      //查询前清除查询列表信息
      this.logs = null;
      //进行分页查询
      this.getRows(_page);
    },

    //初始化表格高度
    initHeight: function() {
      this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },

    
  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.findAllLogs();
    this.getJournalList();
    this.findAllPubs();
    this.findAllProcess();
  }
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #ab99bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .el-input{
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/TransLog.vue